import defaultLogo from "../pages/images/logo-color-horizontal.png";

export const THEME_DEFAULTS = {
  primary: "#1DAF61",
  secondary: "#433AC8",
  backgroundPage: "#FFFFFF",
  textBody: "#171717",
  fontFamily: "Inter",
  logoUrl: defaultLogo,
};
